<template>
  <div class="">
    <div
      class="product-img d-row outlined py-4 px-4"
      :class="selectedOption ? '' : 'emptyImg'"
    >
      <v-img
        class="mx-auto"
        :width="width || 100"
        :src="
          selectedOption
            ? selectedOption.varian_image_url
            : '/assets/seller/add-image-icon.svg'
        "
        @click="uploadCheck"
      ></v-img>
      <v-file-input
        v-model="image"
        label="Upload File"
        prepend-icon="mdi-paperclip"
        outlined
        accept="image/*"
        dense
        v-show="false"
        ref="upload"
        clearable
        @change="onFileChange"
      ></v-file-input>
      <!-- <input type="file" v-show="false" ref="upload" @change="handleUpload" /> -->
      <v-btn
        v-if="selectedOption"
        class="mx-0 close-btn"
        fab
        dark
        x-small
        color="red"
        @click="handleRemove"
      >
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </div>
    <!-- <v-card >
      <v-img class="" :width="width || 100" :src="selectedOption" v-if="selectedOption" @click="handleRemove" /> 
    </v-card> -->
  </div>
</template>
  
  <script>
import { mapMutations } from "vuex";

export default {
  name: "uploadImageVarian",
  props: ["value", "width"],
  data() {
    return {
      loading: false,
      listData: [],
      selectedOption: this.value,
      image: null,
    };
  },
  watch: {
    value(nv, ov) {
      if (!nv) {
        this.selectedOption = null;
        this.$refs.upload.value = null;
      } else {
        this.selectedOption = nv;
      }
    },
  },
  methods: {
    ...mapMutations(["makeAlert"]),
    uploadCheck() {
      if (this.selectedOption) return;
      this.$refs.upload.$refs.input.click();
    },
    onUpload(file) {
      const acceptedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      if (!acceptedTypes.includes(file.type)) {
        this.makeAlert({
          code: "error",
          type: "error",
          message: "File type not accepted",
          show: true,
        });
        // this.$message.error("Image files must be in JPG, PNG, GIF format!");
        this.$refs.upload.value = null;
      } else {
        this.handleUpload(file);
      }
    },
    onFileChange(val) {
      const acceptedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      if (!acceptedTypes.includes(val.type)) {
        this.$message.error("Image files must be in JPG, PNG, GIF format!");
      } else {
        let formData = new FormData();
        formData.append("image", val);
        this.$store
          .dispatch("productSeller/uploadImage", formData)
          .then((response) => {
            const {
              product_image: varian_image,
              product_path: varian_image_url,
            } = response;
            this.uploadNewsPhoto({ varian_image, varian_image_url });
          })
          .catch((error) => {
            this.handleRemove();
            this.makeAlert({
              code: "error",
              type: "error",
              message: "Error Upload!",
              show: true,
            });
          });
      }
    },
    handleUpload(event) {
      const fileInput = this.$refs.upload;
      if (fileInput) {
        const files = fileInput.inputFile.files;
        if (files.length > 0) {
          const uploadedFile = files[0];
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imageUrl = e.target.result;
          };
          reader.readAsDataURL(uploadedFile);
          console.log(reader);
        }
      }
      // const file = event.target.files[0]
      // console.log(file);
      // if (
      //   file.type == "image/jpeg" ||
      //   file.type == "image/jpg" ||
      //   file.type == "image/png" ||
      //   file.type == "image/gif"
      // ) {
      //   const formData = new FormData();
      //   formData.append("image", file);
      //   this.$store
      //     .dispatch("productSeller/uploadImage", formData)
      //     .then((response) => {
      //       this.uploadNewsPhoto(response.product_path);
      //     })
      //     .catch((error) => {
      //       this.handleRemove();
      //       this.$message.error("Error Upload!");
      //     });
      // } else {
      //   this.$message.error("Image files must be in JPG, PNG, GIF format!");
      //   this.$refs.upload.value = null;
      // }
    },
    uploadNewsPhoto(imgUrl) {
      this.selectedOption = imgUrl;
      this.$refs.upload.clearableCallback();
      this.emitInput(imgUrl);
    },
    removeNewsPhoto() {
      this.selectedOption = null;
      this.emitInput(null);
    },
    handleRemove() {
      this.removeNewsPhoto();
      this.$refs.upload.value = null;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed() {
      this.$message.warning(
        "The image already exists, please delete it first to replace it!"
      );
    },
    //handleRemove() {
    //this.selectedOption = null;
    //   this.emitInput();
    // },
    emitInput() {
      // Emit event input saat nilai dropdown berubah
      this.$emit("input", this.selectedOption);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.product-img {
  border: 2px solid green;
  border-radius: 4px;

  &.emptyImg {
    border: 2px solid #ddd;
  }
}

.product-img {
  position: relative;

  .close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    height: 28px;
    width: 28px;
  }
}
</style>
  